/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Waterdepth
 */
export interface Waterdepth {
  /**
   *
   */
  websocketUrl: string;
}

/**
 * Check if a given object implements the Waterdepth interface.
 */
export function instanceOfWaterdepth(value: object): value is Waterdepth {
  if (
    (!("websocketUrl" in (value as Record<string, any>)) &&
      !("websocket_url" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["websocketUrl"] === undefined &&
      (value as Record<string, any>)["websocket_url"] === undefined)
  )
    return false;
  return true;
}

export function WaterdepthFromJSON(json: any): Waterdepth {
  return WaterdepthFromJSONTyped(json, false);
}

export function WaterdepthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Waterdepth {
  if (json == null) {
    return json;
  }
  return {
    websocketUrl: json["websocket_url"],
  };
}

export function WaterdepthToJSON(json: any): Waterdepth {
  return WaterdepthToJSONTyped(json, false);
}

export function WaterdepthToJSONTyped(
  value?: Waterdepth | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    websocket_url: value["websocketUrl"],
  };
}
